import * as colors from "@mui/material/colors";
import { MatchEventType } from "./directus/collections";
import { fromHexToHsl } from "./utils/colors";

export const EVENTS_LABELS: Record<MatchEventType, string> = {
  challenge_hint: "Ispirazione",
  challenge_init: "Avvio",
  challenge_solution: "Successo",
  challenge_error: "Errore",
  challenge_requested_solution: "Resa",
  cta: "Call to Action",
  exit: "Uscita",
  input: "Input",
  withdrawal: "Ritiro materiale",
};

export const ENIGMA_COLORS = {
  "Completamento senza ispirazioni": {
    hex: colors.green[400],
    hsl: fromHexToHsl(colors.green[400]),
    needContrastOnHighIntensity: true,
  },
  "Completamento dopo ispirazioni": {
    hex: colors.green[200],
    hsl: fromHexToHsl(colors.green[200]),
    needContrastOnHighIntensity: true,
  },
  "1° Tentativo": {
    hex: colors.blue[200],
    hsl: fromHexToHsl(colors.blue[200]),
    needContrastOnHighIntensity: true,
  },
  "Ispirazione 1": {
    hex: colors.yellow[200],
    hsl: fromHexToHsl(colors.yellow[200]),
    needContrastOnHighIntensity: false,
  },
  "Ispirazione 2": {
    hex: colors.yellow[500],
    hsl: fromHexToHsl(colors.yellow[500]),
    needContrastOnHighIntensity: false,
  },
  "Ispirazione 3": {
    hex: colors.yellow[800],
    hsl: fromHexToHsl(colors.yellow[800]),
    needContrastOnHighIntensity: true,
  },
  "Ispirazione 4": {
    hex: colors.orange[500],
    hsl: fromHexToHsl(colors.orange[500]),
    needContrastOnHighIntensity: true,
  },
  "Ispirazione 5": {
    hex: colors.orange[700],
    hsl: fromHexToHsl(colors.orange[700]),
    needContrastOnHighIntensity: true,
  },
  Drop: {
    hex: colors.grey[900],
    hsl: fromHexToHsl(colors.grey[900]),
    needContrastOnHighIntensity: true,
  },
  Resa: {
    hex: colors.red[200],
    hsl: fromHexToHsl(colors.red[200]),
    needContrastOnHighIntensity: true,
  },
};
Object.freeze(ENIGMA_COLORS);
